import Vue from 'vue'

const Sortable = require('sortablejs').default
export default class SortableDirective extends Vue {
  bind (el: any, bindings: any) {
    Sortable.create(el, bindings.value || {})
  }
}
